import React from 'react';
import { Badge, Box, Text } from '@wix/design-system';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { useIsMobile } from '../../hooks/useIsMobile';
import s from './AvailableNowBadge.css';
export const AvailableNowBadge = _ref => {
  let _ref$labelKey = _ref.labelKey,
    labelKey = _ref$labelKey === void 0 ? 'domain_search_gate.results.hero.badge.available_now' : _ref$labelKey;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const isMobile = useIsMobile();
  const size = isMobile ? 'tiny' : 'small';
  return /*#__PURE__*/React.createElement(Badge, {
    skin: "success",
    size: size,
    uppercase: false,
    className: s.AvailableNowBadge
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: "SP2",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement("span", {
    className: s.AvailableNowDot
  }), /*#__PURE__*/React.createElement(Text, {
    size: size,
    weight: "normal",
    light: true
  }, t(labelKey))));
};
//# sourceMappingURL=AvailableNowBadge.js.map